<template>
  <div class="ibox">
    <div class="ibox-title"><h5>权限管理</h5></div>
    <div class="ibox-content">
    <div class="crud-bar">
      <el-button type="primary" icon="el-icon-plus" @click="openCreate">新建权限点</el-button>
    </div>
    <el-table :data="list" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="route" label="路由" />
      <el-table-column prop="method" label="方法" width="100" />
      <el-table-column prop="desc" label="描述" />
      <el-table-column label="操作" width="160">
        <template slot-scope="s">
          <el-button size="mini" @click="openEdit(s.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="onDelete(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="420px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="路由"><el-input v-model="form.route" :disabled="!!form.id" placeholder="如 /yljx/admin/administrators" /></el-form-item>
        <el-form-item label="方法">
          <el-select v-model="form.method" placeholder="方法">
            <el-option label="GET" value="GET" />
            <el-option label="POST" value="POST" />
            <el-option label="PUT" value="PUT" />
            <el-option label="DELETE" value="DELETE" />
          </el-select>
        </el-form-item>
        <el-form-item label="描述"><el-input v-model="form.desc" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { permissionsApi } from '../api/admin'

export default {
  name: 'AdminPermissions',
  data () {
    return {
      list: [],
      loading: false,
      dialogVisible: false,
      saving: false,
      editing: null,
      form: { route: '', method: 'GET', desc: '' }
    }
  },
  computed: { dialogTitle () { return this.editing ? '编辑权限点' : '新建权限点' } },
  created () { this.fetch() },
  methods: {
    async fetch () {
      this.loading = true
      try { this.list = await permissionsApi.list() } catch (e) { this.$message.error(e.uiMessage || e.message) } finally { this.loading = false }
    },
    openCreate () { this.editing = null; this.form = { route: '', method: 'GET', desc: '' }; this.dialogVisible = true },
    openEdit (row) { this.editing = row; this.form = { ...row }; this.dialogVisible = true },
    async onSave () {
      if (!this.form.route) return this.$message.warning('请填写路由')
      this.saving = true
      try {
        if (this.editing) await permissionsApi.update(this.editing.id, this.form)
        else await permissionsApi.create(this.form)
        this.$message.success('已保存'); this.dialogVisible = false; this.fetch()
      } catch (e) { this.$message.error(e.uiMessage || e.message) } finally { this.saving = false }
    },
    async onDelete (row) {
      if (!await this.$confirm(`确认删除权限点「${row.route}」？`, '提示', { type: 'warning' }).catch(() => false)) return
      try { await permissionsApi.remove(row.id); this.$message.success('已删除'); this.fetch() } catch (e) { this.$message.error(e.uiMessage || e.message) }
    }
  }
}
</script>

<style scoped>
.crud-bar { margin-bottom: 16px; }
</style>
